import { animate, style, transition, trigger } from '@angular/animations';

// FadeInOut
export const fadeInOutAnimation600 = trigger('fadeInOutAnimation600', [
    transition(':enter', [
        style({ opacity: 0 }),
        animate('0.6s ease', style({ opacity: 1 }))
    ]),
    transition(':leave', [
        animate('0.6s ease', style({ opacity: 0 }))
    ])
]);
export const fadeInOutAnimation400 = trigger('fadeInOutAnimation400', [
    transition(':enter', [
        style({ opacity: 0 }),
        animate('0.4s ease', style({ opacity: 1 }))
    ]),
    transition(':leave', [
        animate('0.4s ease', style({ opacity: 0 }))
    ])
]);
export const fadeInOutAnimation500 = trigger('fadeInOutAnimation500', [
    transition(':enter', [
        style({ opacity: 0 }),
        animate('0.5s ease', style({ opacity: 1 }))
    ]),
    transition(':leave', [
        animate('0.5s ease', style({ opacity: 0 }))
    ])
]);
export const fadeInOutAnimation900 = trigger('fadeInOutAnimation900', [
    transition(':enter', [
        style({ opacity: 0 }),
        animate('2s ease', style({ opacity: 1 }))
    ]),
    transition(':leave', [
        animate('2s ease', style({ opacity: 0 }))
    ])
]);
// FadeInOut

// FadeUpDown
export const fadeUpDownAnimation600 = trigger('fadeUpDownAnimation600', [
    transition(':enter', [
        style({ opacity: 0, transform: 'translateY(60px)', position: 'absolute' }),
        animate('0.6s ease', style({ opacity: 1, transform: 'translateY(0)', position: 'static' }))
    ]),

    transition(':leave', [
        animate('0.6s ease', style({ opacity: 0, transform: 'translateY(60px)', position: 'absolute' }))
    ])
]);

export const fadeUpDownAnimation900 = trigger('fadeUpDownAnimation900', [
    transition(':enter', [
        style({
            opacity: 0,
            transform: 'translateY(60px)',
            position: 'absolute'
        }),
        animate('0.6s 1s ease-in-out', style({
            opacity: 1,
            transform: 'translateY(0)',
            position: 'absolute',
            width: '73.4%',
        }))
    ]),
    transition(':leave', [
        animate('0.6s 1s ease-in-out', style({
            opacity: 0,
            transform: 'translateY(60px)',
            position: 'absolute'
        }))
    ])
]);

export const fadeUpDownAnimation300 = trigger('fadeUpDownAnimation300', [
    transition(':enter', [
        style({ opacity: 0, transform: 'translateY(60px)', position: 'absolute' }),
        animate('0.4s ease-in-out', style({ opacity: 1, transform: 'translateY(0)' }))
    ]),

    transition(':leave', [
        animate('0.4s ease-in-out', style({ opacity: 0, transform: 'translateY(60px)' }))
    ])
]);
// FadeUpDown

export const fadeRightLeftAnimation600 = (lang: any) =>
    trigger('fadeRightLeftAnimation600', [
        transition(':enter', [
            style({
                opacity: 0,
                transform: `translateX(${lang == 'ar' ? '-70px' : '70px'})`,
                position: 'static',
            }),
            animate('0.9s 1s ease-out', style({
                opacity: 1,
                transform: 'translateX(0)',
                position: 'static'
            }))
        ]),
        transition(':leave', [
            animate('0.9s 1s ease', style({
                opacity: 0,
                transform: `translateX(${lang == 'ar' ? '70px' : '-70px'})`,
                position: 'absolute',
                width: '73.6%',
            }))
        ])
    ]);


export function enterFromRightLeaveToLeftAnimation(language: string = 'en') {
    const enterFrom = language === 'ar' ? '-100%' : '100%';
    const leaveTo = language === 'ar' ? '-100%' : '100%';
    return trigger('enterFromRightLeaveToLeftAnimation', [
        transition(':enter', [
            style({ opacity: 0, transform: `translateX(${enterFrom})` }),
            animate('0.5s ease', style({ opacity: 1, transform: 'translateX(0%)' }))
        ]),
        transition(':leave', [
            animate('0.5s ease', style({ opacity: 0, transform: `translateX(${leaveTo})` }))
        ])
    ]);
}


export const fadeInOutAbs300 = trigger('fadeInOutAbs300', [
    transition(':enter', [
        style({
            opacity: 0,
            position: 'absolute'
        }),
        animate('0.9s 0.3s ease', style({
            opacity: 1,
            position: 'absolute',
        }))
    ]),
    transition(':leave', [
        animate('0.9s ease', style({
            opacity: 0,
            position: 'absolute'
        }))
    ])
]);